// src/layout/AdminLayout.jsx
import { Outlet } from "react-router";
import AdminSidebar from "../components/admin/Sidebar";

export default function AdminLayout() {
  return (
    <div className="flex h-[100dvh] min-h-0 flex-col overflow-hidden md:flex-row">
      <AdminSidebar />
      <main className="flex-1 min-h-0 min-w-0 overflow-hidden">
        <div className="h-[calc(100dvh-4.75rem)] overflow-hidden md:h-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
